import { render, staticRenderFns } from "./PidTypeItem.vue?vue&type=template&id=0836f979&scoped=true"
import script from "./PidTypeItem.vue?vue&type=script&lang=js"
export * from "./PidTypeItem.vue?vue&type=script&lang=js"
import style0 from "./PidTypeItem.vue?vue&type=style&index=0&id=0836f979&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0836f979",
  null
  
)

export default component.exports